module.exports = "/images/logo_white.png?f595c5048f1a9144a8acdce9860b5976";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/images/logo_white.png
// module id = WA8s
// module chunks = 0